// http://192.168.0.49:8089/hrms/agency/agencyList

import  { trainingApiClient } from "../../http-common"

export const getRiskLevelDropdown = async () => {
  return await trainingApiClient.get(`/masters/riskLevel/dropdown`);
};

export const getFrequencyTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/frequencyType/dropdown`);
};

export const getFrequencyUnitDropdown = async () => {
  return await trainingApiClient.get(`/masters/frequencyUnit/dropdown`);
};

export const getTrainingTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/trainingType/dropdown`);
};

export const getPreAssessmentDropdown = async () => {
  return await trainingApiClient.get(`/masters/assessmentType/preAssessmentDropdown`);
};

export const getPostAssessmentDropdown = async () => {
  return await trainingApiClient.get(`/masters/assessmentType/postAssessmentDropdown`);
};

// export const getDepartmentDropdown = async () => {
//   return await trainingApiClient.get(`/masters/department/dropdown`);
// };

export const saveTrainingMaster = async (obj) => {
  return await trainingApiClient.post(`/masters/training/save`, obj);
};

export const saveTrainingSchedule = async (obj) => {
  return await trainingApiClient.post(`/trainingSchedule/saveAndUpdate`, obj);
};

export const updateTrainingMaster = async (obj) => {
  return await trainingApiClient.post(`/masters/training/update`, obj);
};

export const getAllTrainingMasterList = async (obj) => {
  return await trainingApiClient.post(`/masters/training/getTrainingList`, obj);
};

export const getAllTrainingAssessmentTestList = async (obj) => {
  return await trainingApiClient.post(`/masters/assessment/list`, obj);
};

export const getAllTrainingName = async (searchString) => {
  return await trainingApiClient.get(`/masters/training/getTrainingAutoComplete`, {
    params: {
      searchString,
    },
  });
};

export const getTrainingDropdown = async () => {
  return await trainingApiClient.get(`/masters/training/getTrainingDropdown`);
};
export const getUnitDropdown = async () => {
  return await trainingApiClient.get(`/masters/unit/unitDropDown`);
};
export const getOptionTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/optionType/dropdown`);
};

export const getDepartmentDropdown = async (id) => {
  return await trainingApiClient.get(`/masters/unit/unitDepartmentMappingDropdown`, {
    params: {
      unitId: id,
    },
  });
};

export const getDeptDropdown = async () => {
  return await trainingApiClient.get(`/masters/department/dropdown`);
};
export const getEmployeeDropdown = async (departmentId) => {
  return await trainingApiClient.get(
    `/masters/unit/departmentEmployeeMappingDropdown`,
    {
      params: {
        departmentId,
      },
    },
  );
};
export const getAssessmentTypeDropdown = async () => {
  return await trainingApiClient.get(`/masters/assessmentType/dropdown`);
};
export const saveAssessment = async (obj) => {
  return await trainingApiClient.post(`/masters/assessment/saveAndUpdate`, obj);
};

export const getTrainingMasterInfo = async (id) => {
  return await trainingApiClient.get(`/masters/training/getTrainingFindById`, {
    params: {
      id,
    },
  });
};

export const getTrainingAssessmentInfo = async (id) => {
  return await trainingApiClient.get(`/masters/assessment/getAssessmentById`, {
    params: {
      assessmentId: id,
    },
  });
};

export const saveGroup = async (obj) => {
  return await trainingApiClient.post(`/masters/Group/save`, obj);
};

export const getAllTrainingScheduleList = async (obj) => {
  return await trainingApiClient.post(
    `/trainingSchedule/getTrainingSchedule
`,
    obj,
  );
};

export const getAllGroupList = async (obj) => {
  return await trainingApiClient.post(`/masters/Group/getGroupList`, obj);
};
export const getGroupDropdown = async () => {
  return await trainingApiClient.get(`/masters/Group/getDropDown`);
};

export const getTrainerDropdown = async () => {
  return await trainingApiClient.get(`/masters/Group/getTrainerDropDown`);
};

export const getLocationDropdown = async () => {
  return await trainingApiClient.get(`/masters/Group/getLocationDropdown`);
};

export const getAllEmployeeName = async (searchString) => {
  return await trainingApiClient.get(`/masters/employee/search/${searchString}`);
};

export const getEmployeesByGroup = async (groupId) => {
  return await trainingApiClient.get(`/masters/Group/getGroupEmployeeDropdown`, {
    params: {
      groupId,
    },
  });
};

export const getEmployeeTrainingSchedule = async (
  trainingId,
  trainingScheduleId,
) => {
  return await trainingApiClient.get(`/trainingSchedule/getEmployeeTrainingSchedule`, {
    params: {
      trainingId,
      trainingScheduleId,
    },
  });
};

export const saveTrainingScheduleCompletion = async (obj) => {
  return await trainingApiClient.post(
    `/trainingSchedule/updateTrainingCompletion`,
    obj,
  );
};
export const saveRecommendation = async (obj) => {
  return await trainingApiClient.post(
    `/trainingRecommendation/saveAndUpdateTrainingRecommendation`,
    obj,
  );
};
export const getTrainingRecommendationList = async (obj) => {
  return await trainingApiClient.post(
    `trainingRecommendation/getRecommendationList`,
    obj,
  );
};

export const getAllTrainingRecommendationEmpName = async (searchString) => {
  return await trainingApiClient.get(
    `/trainingRecommendation/getEmployeeDepartmentDesignationMapping`,
    {
      params: {
        searchString,
      },
    },
  );
};

export const getRecommendedEmpByTraining = async (trainingId) => {
  return await trainingApiClient.get(
    `/trainingRecommendation/getRecommendationEmployee`,
    {
      params: {
        trainingId,
      },
    },
  );
};

export const getTrainingScheduleInfo = async (id) => {
  return await trainingApiClient.get(`/trainingSchedule/getDataTrainingScheduleId`, {
    params: {
      trainingScheduleId: id,
    },
  });
};

export const getRecommendedEmployees = async (id) => {
  return await trainingApiClient.get(`/masters/training/getTrainingFindById`, {
    params: {
      id,
    },
  });
};

export const getMyTrainingList = async (id) => {
  return await trainingApiClient.get(`/masters/assessment/getEmployeeTrainingData`, {
    params: {
      employeeId: id,
    },
  });
};

export const getAssessmentQuestionsList = async (trainingId, assessmentId) => {
  return await trainingApiClient.get(`/masters/assessment/getAssessmentQuestion`, {
    params: {
      trainingId,
      assessmentId,
    },
  });
};

export const getGroupMasterInfo = async (id) => {
  return await trainingApiClient.get(`/masters/Group/getGroupData`, {
    params: {
      groupId: id,
    },
  });
};

export const saveAssessmentTest = async (obj) => {
  return await trainingApiClient.post(`/employeeAssessmentScore/save`, obj);
};

export const getTrainingScheduleDetailsInfo = async (id) => {
  return await trainingApiClient.get(
    `/trainingSchedule/getTrainingScheduleDetailsData`,
    {
      params: {
        trainingScheduleId: id,
      },
    },
  );
};

export const getTrainingRecommedationInfo = async (id) => {
  return await trainingApiClient.get(
    `/trainingRecommendation/getRecommendationFindById`,
    {
      params: {
        trainingId: id,
      },
    },
  );
};

export const getTrainingDocuments = async (documentName) => {
  return await trainingApiClient.get(`/masters/document/${documentName}`, {
    responseType: "blob",
  });
};
export const getTrainingVideos = async (documentName) => {
  return await trainingApiClient.get(`/masters/video/${documentName}`, {
    responseType: "blob",
  });
};
export const getRoleDropdown = async () => {
  return await trainingApiClient.get(`/masters/training/getRoleDropdown`);
};